<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />
  <p-card>
    <ng-template #title>
      <h1>{{ 'controlPoints.controlPoints.title' | translate }}</h1>
    </ng-template>

    @if (service.items().length === 0) {
      <div
        class="flex flex-col items-center justify-center text-center gap-4 py-16"
      >
        <i
          class="fa-regular fa-location-crosshairs text-4xl text-color-secondary"
        ></i>
        <p class="text-color-secondary">
          {{ 'controlPoints.controlPoints.empty' | translate }}
        </p>
        <p-button
          icon="fa fa-plus"
          [label]="'controlPoints.controlPoints.create' | translate"
          (onClick)="navigateToCreate()"
        />
      </div>
    } @else {
      <div class="flex justify-end gap-2 mb-5">
        <p-button
          icon="fa fa-plus"
          [label]="'controlPoints.controlPoints.add' | translate"
          (onClick)="navigateToCreate()"
        />
      </div>

      <p-table
        [value]="service.items()"
        stripedRows
        showGridlines
        dataKey="id"
        [paginator]="true"
        [rows]="25"
        sortField="name"
        [sortOrder]="1"
        [scrollable]="true"
        [tableStyle]="{ 'min-width': '50rem' }"
      >
        <ng-template #header>
          <tr>
            <th pSortableColumn="name">
              {{ 'controlPoints.controlPoints.fields.name' | translate }}
              <p-sortIcon field="name" />
            </th>
            <th pSortableColumn="interval_minutes">
              {{
                'controlPoints.controlPoints.fields.intervalMinutes' | translate
              }}
              <p-sortIcon field="interval_minutes" />
            </th>
            <th pSortableColumn="tag_name">
              {{ 'controlPoints.controlPoints.fields.tagName' | translate }}
              <p-sortIcon field="tag_name" />
            </th>
            <th>
              {{ 'controlPoints.controlPoints.fields.qualifications' | translate }}
            </th>
            <th pFrozenColumn alignFrozen="right" class="w-32"></th>
          </tr>
        </ng-template>
        <ng-template #body let-row>
          <tr class="cursor-pointer" (click)="navigateToDetail(row)">
            <td>{{ row.name }}</td>
            <td>{{ row.interval_minutes }}</td>
            <td class="font-mono">{{ row.tag_name }}</td>
            <td>
              @if (qualificationNames(row).length === 0) {
                <span class="text-color-secondary">—</span>
              } @else {
                <div class="flex flex-wrap gap-1">
                  @for (name of qualificationNames(row); track name) {
                    <p-tag [value]="name" severity="secondary" />
                  }
                </div>
              }
            </td>
            <td pFrozenColumn alignFrozen="right">
              <div class="flex items-center justify-end gap-2">
                <button
                  pButton
                  type="button"
                  icon="fa fa-pencil"
                  text
                  rounded
                  severity="secondary"
                  (click)="navigateToDetail(row); $event.stopPropagation()"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="fa fa-trash"
                  text
                  rounded
                  severity="secondary"
                  (click)="onRowDelete($event, row); $event.stopPropagation()"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </p-card>
</div>
